import { CustomDate } from "../../custom-date/custom-date";
export class TnADateTime {
  year: number = 0;
  month: number = 0;
  day: number = 0;
  hour: number = 0;
  minute: number = 0;
  second: number = 0;

  public static ToTnADate(tnADateTime: TnADateTime | null): CustomDate {
    const result = tnADateTime
      ? ({
          year: tnADateTime.year,
          month: tnADateTime.month,
          day: tnADateTime.day,
        } as CustomDate)
      : ({
          year: 1,
          month: 1,
          day: 1,
        } as CustomDate);
    return result;
  }

  public static ToDate(tnADateTime: TnADateTime | null): Date {
    const result = tnADateTime ? new Date(tnADateTime.year, tnADateTime.month - 1, tnADateTime.day) : new Date();
    return result;
  }

  public static ToDateTime(tnADateTime: TnADateTime | null): Date {
    const result = tnADateTime
      ? new Date(
          tnADateTime.year,
          tnADateTime.month - 1,
          tnADateTime.day,
          tnADateTime.hour,
          tnADateTime.minute,
          tnADateTime.second
        )
      : new Date();
    return result;
  }

  public static FromDate(date: Date): TnADateTime {
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      hour: date.getHours(),
      minute: date.getMinutes(),
      second: date.getSeconds(),
    } as TnADateTime;
  }
}
